export default "/_next/static/images/e3ea3758de51c942dd1c38584de42a37.jpg";